import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { MEDIUM } from '../utils/styled';
const ToggleContainer = styled.div `
    box-sizing: border-box;
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: inset 0px -1px 1px rgba(255, 255, 255, 0.1), inset 0px 1px 1px rgba(255, 255, 255, 0.25);
    backdrop-filter: blur(3.125rem);
    -webkit-backdrop-filter: blur(3.125rem);
    border-radius: 0.75rem;
    position: relative;
    padding: 0.5rem;
    user-select: none;
`;
const Slider = styled.div `
    position: absolute;
    left: 0.5rem;
    top: 0.5rem;
    height: calc(100% - 1rem);
    width: calc(50% - 0.5rem);
    background: rgba(255, 255, 255, 0.3);
    border-radius: 0.375rem;
    transition: transform 200ms ease;
    transform: translateX(${(props) => (props.selected === props.options[1] ? '100%' : '0')});
`;
const ToggleButton = styled.label `
    padding: 0.3125rem 0.75rem;
    border-radius: 0.375rem;
    font-weight: ${MEDIUM};
    font-size: 0.9375rem;
    cursor: pointer;
    color: #FFFFFF;
    position: relative;
    z-index: 1;
`;
const RadioInput = styled.input `
    position: absolute;
    opacity: 0;
`;
export const Toggle = ({ options, selected, onChange, }) => {
    return (_jsxs(ToggleContainer, { children: [_jsx(Slider, { options: options, selected: selected }), options.map((option) => (_jsxs("div", { children: [_jsx(RadioInput, { type: "radio", name: "toggle", id: option, value: option, checked: selected === option, onChange: (e) => onChange(e.target.value) }), _jsx(ToggleButton, { htmlFor: option, children: option })] }, option)))] }));
};
